<template>
  <app-section-wrap :modifier="'login'">
    <div column="+1 10 +1">
      <div class="split-card">
        <div class="card-left">
          <h1 class="_text-center _mbs">
          Forgot User ID?
        </h1>
        <cloud-cannon-content
          v-if="!submitted"
          class="_p0 _ptxs _pbxs"
          :content-loading="cloudCannonContentLoading"
          :content="cloudCannonContent.header"
        />
        <p class="_mt0 _text-center" role="status" v-if="submitted">{{userMessage}}</p>
        <form v-if="!submitted" ref="form" @submit.prevent="sendUserIdEmail">
          <p class="alert _mt0 lips" role="alert" v-if="error">{{errorMessage}}</p>
          <app-input
            v-model='$v.email.$model'
            valueKey='Email'
            type="email"
            :required="true"
            :errorMessage="emailError"
            :invalid="$v.email.$invalid"
            label='Email:'
            modifier=""/>
          <async-button type="submit" class="_mtxs --sm" :executing="submitting" :disabled="disable">
            <template #buttonContent>
              <span>
                Send User ID Reminder Email
              </span>
            </template>
          </async-button>
        </form>
        <router-link id="back-to-login" to='/'>Back to Sign In screen</router-link>
      </div>
        <div class="card-divider"></div>

        <div class="card-right">
      
        </div>
      </div>
    </div>
  </app-section-wrap>
</template>

<script>
  import LoginApi from '@api/LoginApi'
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@/components/molecules/AsyncButton.vue'
  import AppInput from '@atoms/Input'
  import fetchable from '@mixins/fetchable'
  import CloudCannonable from '@mixins/CloudCannonable'
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    mixins: [
      fetchable,
      CloudCannonable
    ],
    components: {
      AppSectionWrap,
      AsyncButton,
      AppInput
    },
    data() {
      return {
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/forgot-userid.json'
            },
            config: {
              root: true
            }
          }
        ],
        email: '',
        userMessage: '',
        errorMessage: '',
        submitted: false,
        submitting: false,
        error: false
      }
    },
    validations: {
      email: {
        required,
        email
      }
    },
    computed: {
      formObject() {
        return {
          email: this.email
        }
      },
      emailError() {
        if (!this.$v.email.required) {
          return 'required'
        } else if (!this.$v.email.email && this.$v.email.$dirty) {
          return 'not a valid email address'
        } else {
          return ''
        }
      },
      disable() {
        if (!this.$v.$invalid) {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      sendUserIdEmail() {
        this.submitting = true
        new LoginApi().forgotUserId({
          params: { success: true },
          // params: { invalid: true },
          // params: { expired: true },
          // params: { exceeded: true },
          body: this.formObject
        })
          .then(resp => {
            this.submitting = false
            this.submitted = true
            this.userMessage = resp.userMessage
          })
          .catch(error => {
            error.response.json().then(resp => {
              this.errorMessage = resp.userMessage
            })
            this.submitting = false
            this.error = true
          })
      }
    }
  }
</script>
